$(document).ready(function () {
  $('#service-detail .anchor-to-video').on('click', function (evt) {
    let videoUrl = $('.content-outer video source').attr('src');
    let loader = $('.content-outer video').attr('poster');
    let template =
      `<video preload='metadata'
        poster='${loader}'
        autoplay controls
        src='${videoUrl}'></video>`

    $('#fullscreen-modal .media-item').append(template);
    $('#fullscreen-modal').css('display', 'flex');
  });

  let controller = new ScrollMagic.Controller();

  let showPortfolioItems = document.getElementById('service-detail').getElementsByClassName("portfolio-item");
  for (let i = 0; i < showPortfolioItems.length; i++) {
    new ScrollMagic.Scene({
      triggerElement: showPortfolioItems[i],
      offset: 50,
      triggerHook: 0.9,
      reverse: false
    })
      .setClassToggle(showPortfolioItems[i], "visiblePortfolioItems")
     // .addIndicators({name: "showElementsProj" })
      .addTo(controller);
  }

  let list = document.getElementById('service-detail').getElementsByClassName("list")[0];
  let txt = document.getElementById('service-detail').getElementsByClassName("description")[0];
  let showDescArticle = [list, txt]

  for (let i = 0; i < showDescArticle.length; i++) {
    new ScrollMagic.Scene({
      triggerElement: showDescArticle[i],
      offset: 50,
      triggerHook: 0.9,
      reverse: false
    })
      .setClassToggle(showDescArticle[i], "visibleInfo")
      //.addIndicators({name: "showElementsProj" })
      .addTo(controller);
  }
});
